/** Eternal City copy, es. Machine assisted from the English, pending review; proper names and {placeholders} kept as in English. NPC dialogue stays English. */
export const cityEs: Record<string, string> = {
  'city.seoDescription': 'Entra en una ciudad viva. Todos siguen una rutina diaria. Sigue a ellos, habla con ellos, y pasa un día junto a las personas que viven sin ti.',
  'city.intro': 'Una ciudad viva. Todos aquí mantienen una rutina diaria, y el tiempo pasa mientras juegas.',
  'city.back': 'De vuelta al mundo',
  'city.connecting': 'Abrir las puertas de la ciudad...',
  'city.reconnecting': 'Perdí el hilo.',
  'city.offline': 'La ciudad está fuera de alcance en este momento, por favor vuelva a intentarlo en un momento.',
  'city.signinTitle': 'Ingrese para entrar',
  'city.signinBody': 'Su lugar en la ciudad, su diario y la gente que conoció se guardan para su cuenta.',
  'city.signinCta': 'Regístrese',
  'city.privacy': 'Cómo manejamos estos datos: Política de privacidad',
  'city.blocked': 'La ciudad no está abierta a esta cuenta en este momento.',
  'city.openElsewhere': 'Esta ciudad está abierta en otra pestaña. Cierra esa o recarga aquí.',
  'city.canvasLabel': 'Mapa isométrico de {city}. Usa las listas al lado para hablar, caminar y mirar a tu alrededor.',
  'city.hint': 'Haga clic en el suelo para caminar, o haga clic en una persona para hablar.',
  'city.holiday': 'Hoy en día: {name}',
  'city.here': 'Usted está en {place}.',
  'city.commons.empty': 'Este es un espacio compartido, y no hay otros viajeros aquí en este momento.',
  'city.commons.here.one': 'Este es un espacio compartido, y otro viajero está aquí.',
  'city.commons.here.other': 'Este es un espacio compartido, y {count} otros viajeros están aquí.',
  'city.commons.peer': 'un compañero de viaje',
  'city.crowd.name': 'Ciudadano',
  'city.travel.ride': 'Conduce hacia {place} (cerca de {n} Minutos)',
  'city.wares.now': 'Ahora mismo: {list}',
  'city.wares.none': 'No hay nada dispuesto a esta hora.',
  'city.wares.few': '{name} (algunos a la izquierda)',
  'city.wares.last': '{name} (el último)',
  'city.places': 'Ve a un lugar .',
  'city.goPlace': 'Ir a {place}',
  'city.dialogueAnnounce': 'Las opciones se anuncian a medida que aparecen.',
  'city.people': '¿Quién está por aquí?',
  'city.peopleNone': 'No hay nadie a la vista.',
  'city.talk': 'Habla',
  'city.goto': 'Camina hacia aquí.',
  'city.away': '{n} los pasos lejos',
  'city.scenes': 'Está sucediendo en las cercanías.',
  'city.watch': 'Únete a nosotros .',
  'city.props': 'Mira por aquí.',
  'city.examine': 'Mira , mira .',
  'city.open': 'Abierto',
  'city.take': 'Toma eso.',
  'city.menu.open': 'Abierto {thing}',
  'city.menu.take': 'Toma lo que hay en {thing}',
  'city.menu.walkToThing': 'Camina hacia {thing}',
  'city.dialogue': 'Conversación',
  'city.close': 'Cercano',
  'city.leave': 'Deja la conversación',
  'city.menu.talk': 'Habla con {name}',
  'city.menu.walkTalk': 'Caminar hacia {name}',
  'city.menu.walkTo': 'Camina hacia {name}',
  'city.menu.walkHere': 'Camina aquí.',
  'city.menu.swimHere': 'Baña aquí.',
  'city.menu.rowHere': 'Envuelve aquí.',
  'city.mount.down': 'Baja de aquí. {name}',
  'city.companion.home': 'Envía {name} en el hogar',
  'city.rumours.title': 'Tabla de rumores',
  'city.rumours.none': 'Estar cerca de la gente de la ciudad hablando juntos, en la taberna sobre todo, y lo que dicen está pegado aquí.',
  'city.rumours.said': 'dijo {name}',
  'city.greet.title': 'Conocido por su nombre',
  'city.greet.callMe': '¿Cómo te llaman los habitantes de la ciudad?',
  'city.greet.placeholder': 'Su nombre .',
  'city.greet.none': 'Nadie te conoce todavía. Mira y habla con alguien, y la próxima vez te saludarán por nombre.',
  'city.greet.morning.0': 'Por la mañana. {name}!',
  'city.greet.morning.1': 'Buenas mañanas a usted, {name}.',
  'city.greet.morning.2': 'Me levanté temprano. {name}?',
  'city.greet.afternoon.0': '¿Qué pasa? {name}.',
  'city.greet.afternoon.1': 'Buen día. {name}!',
  'city.greet.afternoon.2': 'Bien conocido otra vez, {name}.',
  'city.greet.evening.0': 'Por la noche, {name}.',
  'city.greet.evening.1': 'Buenas noches. {name}!',
  'city.greet.evening.2': 'Fuera de casa, {name}?',
  'city.greet.night.0': 'Es tarde para salir. {name}.',
  'city.greet.night.1': 'Cuidado con la oscuridad. {name}.',
  'city.greet.night.2': 'Aún así, {name}?',
  'city.greet.morning.0.anon': '¡Bueno día, amigo!',
  'city.greet.morning.1.anon': 'Buenas mañanas para ti.',
  'city.greet.morning.2.anon': '¿Se levantó temprano, amigo?',
  'city.greet.afternoon.0.anon': 'Buenas tardes, amigo.',
  'city.greet.afternoon.1.anon': '¡Bueno día para ti!',
  'city.greet.afternoon.2.anon': 'Bien conocido de nuevo.',
  'city.greet.evening.0.anon': 'Esta noche, amigo.',
  'city.greet.evening.1.anon': '¡Buena noche!',
  'city.greet.evening.2.anon': '¿Fuera de casa, amigo?',
  'city.greet.night.0.anon': 'Es tarde para salir, amigo.',
  'city.greet.night.1.anon': 'Cuidado con la oscuridad.',
  'city.greet.night.2.anon': '¿Todavía por aquí, amigo?',
  'city.market.title': 'Tabla de mercado',
  'city.market.shut': 'Ahora mismo no hay nada.',
  'city.market.later': 'Más tarde hoy:',
  'city.market.am': '{n} en la mañana',
  'city.market.pm': '{n} en la tarde',
  'city.market.eve': '{n} en la noche',
  'city.garden.title': 'Planas de jardín',
  'city.garden.tend': 'Cuidado con la trama.',
  'city.garden.tended': 'Sacas algunas malezas y regas la parcela.',
  'city.garden.already': 'Ya has atendido esta trama hoy.',
  'city.garden.tendedNote': 'que se ha atendido hoy',
  'city.garden.arrive': 'El Consejo {crop} Aquí están {stage}.',
  'city.garden.crop.herbs': 'hierbas',
  'city.garden.crop.apples': 'árboles de manzana',
  'city.garden.crop.kitchen': 'vegetales de cocina',
  'city.garden.crop.cabbages': 'Cabras y frijoles',
  'city.garden.crop.wheat': 'campos de trigo',
  'city.garden.stage.bare': 'Desnudos para el invierno',
  'city.garden.stage.sown': 'semillado recientemente',
  'city.garden.stage.sprouting': 'que brotan',
  'city.garden.stage.growing': 'creciendo bien',
  'city.garden.stage.flowering': 'en flor',
  'city.garden.stage.ripe': 'maduro y listo',
  'city.garden.stage.harvested': 'cosechadas para el año',
  'city.fish.title': 'Pesca y pesca',
  'city.fish.cast': 'Arrojar una línea',
  'city.fish.go': '¡Ve ahora!',
  'city.fish.here': 'Un buen lugar para pescar.',
  'city.fish.casting': 'Haz una fila y espera.',
  'city.fish.caught': 'Algo muerde. {fish}.',
  'city.fish.got.boot': 'Se enrolla en una vieja bota y se la vuelve a tirar.',
  'city.fish.got.weed': 'Sólo hierba de río esta vez.',
  'city.fish.got.nothing': 'Nada muerde, el agua guarda sus secretos.',
  'city.fish.casts': '{n} lanza hasta ahora',
  'city.fish.none': 'Los peces pican mejor al amanecer y al atardecer, y más en primavera y otoño.',
  'city.fish.spot.bank': 'la orilla del río',
  'city.fish.spot.jetty': 'Jetty',
  'city.fish.spot.bridge': 'puente de molino',
  'city.fish.name.perch': 'una percha',
  'city.fish.name.roach': 'una cucaracha',
  'city.fish.name.trout': 'una trucha',
  'city.fish.name.eel': 'una anguila',
  'city.fish.name.pike': 'un picón',
  'city.fish.name.carp': 'una carpa',
  'city.fish.name.minnow': 'un pequeño pescado',
  'city.fish.name.crayfish': 'un cangrejo',
  'city.fish.name.boot': 'Una vieja bota',
  'city.fish.name.weed': 'hierba del río',
  'city.fish.name.nothing': 'No hay nada.',
  'city.lost.title': 'Perdidos y encontrados',
  'city.lost.none': 'La gente de la ciudad deja cosas en los mercados, la plaza y otros lugares ocupados.',
  'city.lost.whose': 'pertenece a {name}',
  'city.lost.find': 'Encuentra {name}',
  'city.lost.spot': 'Hay algo en el suelo aquí: {thing}',
  'city.lost.pick': 'Recoge. {thing}',
  'city.lost.picked': 'Tú contestas . {thing}. Parece que pertenece a {name}.',
  'city.lost.give': 'Damos {thing} de vuelta a {name}',
  'city.lost.thanks': '{name} Me alegra tener {thing} ¿Qué pasa?',
  'city.lost.thing.glove': 'un guante perdido',
  'city.lost.thing.keys': 'un anillo de llaves',
  'city.lost.thing.locket': 'un pequeño medallón',
  'city.lost.thing.toy': 'un juguete de madera',
  'city.lost.thing.scarf': 'una bufanda de lana',
  'city.lost.thing.purse': 'un bolso vacío',
  'city.lost.thing.spectacles': 'un par de gafas',
  'city.lost.thing.letter': 'una carta doblada',
  'city.lost.thing.ribbon': 'una cinta para el cabello',
  'city.lost.thing.pipe': 'una tubería de arcilla',
  'city.records.title': 'Registros municipales',
  'city.records.peak': 'Lo más ocupado de hoy en {time}, con {n} gente de la ciudad por ahí.',
  'city.records.now': 'A esta hora: {out} fuera, {home} En casa.',
  'city.records.busiest': 'Cuarto más ocupado: {district}.',
  'city.records.outTitle': 'La gente de la ciudad está fuera, por hora.',
  'city.records.seenTitle': 'Las personas que viste a tu alrededor, por hora',
  'city.a11y.title': 'Accesividad',
  'city.a11y.text': 'Tamaño del texto',
  'city.a11y.size1': 'Normal',
  'city.a11y.size125': 'Gran cantidad',
  'city.a11y.size15': 'El más grande',
  'city.a11y.stillOff': 'Reducir el movimiento',
  'city.a11y.stillOn': 'La moción se redujo',
  'city.a11y.contrastOff': 'Alto contraste',
  'city.a11y.contrastOn': 'Alto contraste en',
  'city.tour.welcome.title': 'Bienvenido a {city}',
  'city.tour.welcome.body': 'Esta ciudad vive en su propio reloj. La gente se despierta, trabaja, come y duerme, ya sea que miren o no. Aquí hay un breve vistazo a su alrededor.',
  'city.tour.walk.title': 'Caminando',
  'city.tour.walk.body': 'Toque cualquier terreno abierto para caminar allí. Su robot encuentra su propio camino alrededor de las paredes y a través de las puertas.',
  'city.tour.talk.title': 'Hablando',
  'city.tour.talk.body': 'Toca a una persona para ver su nombre y acércate. Una vez que estés cerca, toca otra vez para hablar. Sus palabras aparecen junto a su cabeza.',
  'city.tour.menu.title': 'Mirando más de cerca',
  'city.tour.menu.body': 'En una computadora, haga clic derecho en cualquier cosa para ver lo que puede hacer allí, como leer un letrero, sentarse o tomar una habitación.',
  'city.tour.map.title': 'El mapa mínimo',
  'city.tour.map.body': 'El pequeño mapa en la esquina muestra carreteras, distritos y personas cerca de usted.',
  'city.tour.panel.title': 'Su panel',
  'city.tour.panel.body': 'El panel lateral muestra las personas cercanas, los lugares que has descubierto, tus misiones, tu diario y más.',
  'city.tour.keys.title': 'Movimientos',
  'city.tour.keys.body': 'El botón del teclado muestra cada movimiento que su robot conoce.',
  'city.tour.done.title': 'Eso es todo.',
  'city.tour.done.body': 'Disfruta {city}. Puedes hacer este recorrido de nuevo desde el panel lateral.',
  'city.tour.step': '{n} del {total}',
  'city.tour.next': 'Lo siguiente .',
  'city.tour.back': 'De vuelta',
  'city.tour.skip': 'Salta el recorrido .',
  'city.tour.finish': 'Empieza a explorar',
  'city.tour.again': 'Vuelva por la ciudad otra vez.',
  'city.found.title': 'Lugares descubiertos',
  'city.found.count': '{n} del {total}',
  'city.found.none': 'Caminar a un lugar para agregarlo aquí.',
  'city.found.new': 'Descubierto {place}',
  'city.board.open': 'Lea el tablero de notas públicas',
  'city.board.hint': 'Las notas dejadas aquí por otros viajeros. Encuentra una corta de la tuya; sin enlaces, y hasta tres de los tuyos se quedan arriba a la vez.',
  'city.board.placeholder': 'Escriba una breve nota para que otros la encuentren.',
  'city.board.pin': 'Encuentra la nota.',
  'city.board.loading': 'Leyendo el tablero...',
  'city.board.by': '{name}, {when}',
  'city.board.remove': 'Escribe tu nota.',
  'city.board.err.signin': 'Regístrate para fijar una nota.',
  'city.board.err.soon': 'Espera un poco antes de poner otra nota.',
  'city.board.err.bad': 'Las notas deberán ser texto en blanco de hasta 200 caracteres, sin enlaces.',
  'city.board.err.down': 'No se puede contactar con la junta en este momento.',
  'city.room.rent': 'Tómate una habitación en {place}',
  'city.room.move': 'Mueve tu habitación a {place}',
  'city.room.yours': 'Su habitación en {place}',
  'city.room.decorate': 'Pon algo aquí.',
  'city.room.remove': 'Quítate el {thing}',
  'city.room.leave': 'Deja tu habitación.',
  'city.room.full': 'Tu habitación no tiene espacio para más.',
  'city.room.pickTitle': 'Mueble su habitación',
  'city.room.pickHint': 'Elige algo para poner en este lugar. Se queda en tu habitación en este dispositivo.',
  'city.room.kind.rug': 'Una alfombra tejida',
  'city.room.kind.candle': 'Una vela',
  'city.room.kind.flowers': 'Una olla de flores',
  'city.room.kind.painting': 'Un cuadro',
  'city.room.kind.plant': 'Una planta en maceta',
  'city.room.kind.chest': 'Un pequeño pecho .',
  'city.room.kind.lantern': 'Una linterna',
  'city.room.kind.books': 'Unos cuantos libros.',
  'city.busk.lute': '{name} Se escucha una melodía brillante cerca.',
  'city.busk.fiddle': '{name} se saca un rollo animado cerca',
  'city.busk.pipe': '{name} Juega un aire lento cerca',
  'city.busk.drum': '{name} Se da un baile cerca.',
  'city.tail.label': 'Siguiendo {name}',
  'city.tail.title': 'La cola {name} a lo largo del día',
  'city.tail.now': 'Ahora ... {activity} en el {place}',
  'city.tail.unknown': 'Sus planes para ahora son desconocidos.',
  'city.tail.next': 'Lo siguiente: {place} en el {time}, en {h} h {m} por lo menos',
  'city.tail.trail': 'Trazado por: {places}',
  'city.tail.stop': 'Deja de seguir',
  'city.pins.add': 'Añadir un pin',
  'city.pins.tapMap': 'Toque el mapa para colocar su pin',
  'city.pins.walk': 'Camina hacia este pin.',
  'city.pins.note': 'Pinar en {x}, {y}. Añadir una nota',
  'city.pins.noteLabel': 'Nota de fijación',
  'city.pins.remove': 'Quita este pin.',
  'city.pins.here': 'Pinta este punto en el mapa',
  'city.compass.north': 'Al norte',
  'city.compass.at': 'x {x}, y {y}, piso {floor}',
  'city.door.prop': 'Ponte la puerta abierta',
  'city.door.close': 'Deja que la puerta se cierre',
  'city.door.unlock': 'Desbloquea la puerta.',
  'city.door.lock': 'Cierra la puerta.',
  'city.books.browse': 'Explora el estante',
  'city.books.shelf': 'Estante en {place}',
  'city.books.book': 'Libro',
  'city.books.scroll': 'Descarga',
  'city.books.prev': 'Anteriormente',
  'city.books.back': 'De vuelta al estante.',
  'city.books.next': 'Lo siguiente .',
  'city.books.page': 'Página {n} de {of}',
  'city.sign.readSign': 'Lea la señal.',
  'city.sign.readPlaque': 'Lea la placa',
  'city.sign.sign': 'Un letrero pintado',
  'city.sign.plaque': 'Una placa junto a la puerta',
  'city.district.entering': 'Entrando ahora',
  'city.district.riverside': 'La orilla del río y los mercados bajos',
  'city.district.sunwalk': 'Paseo al sol',
  'city.district.lanes': 'Los carriles',
  'city.district.monastery': 'El monasterio',
  'city.district.castle': 'El Castillo',
  'city.district.drains': 'Los viejos drenajes',
  'city.district.farmlands': 'Las tierras de cultivo',
  'city.photo.enter': 'Modo de fotografía',
  'city.photo.hint': 'Modo de fotografía: arrastre para mirar a su alrededor, tome una captura de pantalla para mantenerla.',
  'city.photo.leave': 'Deja el modo de la foto',
  'city.building.who': 'Quien vive y trabaja en {place}',
  'city.building.live': 'Vive aquí.',
  'city.building.work': 'Trabaja aquí.',
  'city.building.now': 'En el interior ahora',
  'city.building.rooms': 'Se activan {list}.',
  'city.inspect.about': 'En cuanto a {name}',
  'city.inspect.close': 'Cercano',
  'city.inspect.unknown': 'Nadie puede decirte mucho sobre {name}.',
  'city.inspect.home': 'En el hogar',
  'city.inspect.work': 'Trabajo',
  'city.inspect.none': 'Ninguno conocido',
  'city.inspect.today': 'Hoy en día',
  'city.inspect.row': '{what}, {place}',
  'city.inspect.follow': 'Sigue {name} a lo largo del día',
  'city.overlay.label': 'Superposición de mapas',
  'city.overlay.crowd': 'Multitudes',
  'city.overlay.light': 'La luz',
  'city.overlay.noise': 'El ruido',
  'city.bar.pop': '{n} Vivir aquí',
  'city.bar.out': '{n} Ahora fuera.',
  'city.bar.season.spring': 'Primavera',
  'city.bar.season.summer': 'El verano',
  'city.bar.season.autumn': 'El otoño',
  'city.bar.season.winter': 'Invierno',
  'city.notebook.title': 'Escuchado y aprendido',
  'city.notebook.all': 'Todo el mundo .',
  'city.notebook.heard': 'He escuchado .',
  'city.notebook.learned': 'Aprendió',
  'city.notebook.search': 'Busca en tus notas.',
  'city.notebook.none': 'Aún no se ha notado nada, escucha en las calles y habla con la gente.',
  'city.ask.title': 'Pregunte por ahí.',
  'city.ask.pick': '¿A quién buscas?',
  'city.ask.ask': 'Pregunte',
  'city.ask.passerby': 'Un transeúnte',
  'city.ask.nobody': 'No hay nadie lo suficientemente cerca como para preguntar.',
  'city.ask.unseen': '{asker} no ha visto {who} acerca de hoy.',
  'city.ask.here': '{asker} dice {who} está cerca {place}.',
  'city.ask.go': 'Ir a {who}',
  'city.weather.clear': 'Los cielos claros',
  'city.weather.cloudy.light': 'Un par de nubes .',
  'city.weather.cloudy.heavy': 'Gris y nublado',
  'city.weather.rain.light': 'Una lluvia ligera',
  'city.weather.rain.heavy': 'Fuertes lluvias',
  'city.weather.fog.light': 'La niebla de la mañana',
  'city.weather.fog.heavy': 'Niebla espesa',
  'city.weather.snow.light': 'Nieve ligera',
  'city.weather.snow.heavy': 'Fuerte nieve',
  'city.lamplighter.name': 'El alumbrador',
  'city.lamplighter.lighting': 'encender las lámparas de la calle',
  'city.lamplighter.dousing': 'apagar las lámparas de la calle',
  'city.hourglass.title': 'Reloj de arena',
  'city.hourglass.stop': 'Para el día.',
  'city.hourglass.paused': 'El día se detiene.',
  'city.hourglass.resume': 'Vamos , adelante .',
  'city.seat.bench': 'banco',
  'city.seat.chair': 'la silla',
  'city.seat.sit': 'Siéntate en el {what}',
  'city.inside.crate': 'caja',
  'city.inside.barrel': 'barril',
  'city.inside.title': 'En el interior del {what}',
  'city.inside.look': 'Mira en el {what}',
  'city.inside.holds': 'Es {fill}: {list}.',
  'city.factions.title': 'De pie en la ciudad',
  'city.factions.wary': 'Cuidado .',
  'city.factions.unknown': 'Desconocido',
  'city.factions.noticed': 'Se notó',
  'city.factions.trusted': 'Confiable',
  'city.factions.honored': 'Con honor',
  'city.factions.done': 'Las órdenes hechas: {n}.',
  'city.mail.title': 'Las cartas',
  'city.mail.none': 'Aún no hay cartas.',
  'city.mail.from': 'Desde {name}',
  'city.mail.waiting': 'Esperando una respuesta de {names}.',
  'city.mail.nobody': 'Ayuda a alguien con un recado y puedes escribirles.',
  'city.mail.write': 'Escriba una carta.',
  'city.mail.to': '¿A quién?',
  'city.mail.subject': 'Subyecto',
  'city.mail.body': 'Su carta',
  'city.mail.send': 'Envíalo .',
  'city.mail.untitled': 'Un par de líneas .',
  'city.moth.title': 'La bandeja de la mariposa',
  'city.moth.trade': 'Hazme un favor .',
  'city.moth.yours': 'Ahora es tuyo.',
  'city.spy.title': 'Trabajo silencioso',
  'city.cut.skip': 'Salta',
  'city.party.title': 'Juega juntos.',
  'city.party.blurb': 'Empieza una fiesta y comparte su código con amigos. Todos en ella se ven en cualquier parte de la ciudad, no sólo en los espacios compartidos.',
  'city.party.start': 'Empieza una fiesta.',
  'city.party.codeLabel': 'Código de partido',
  'city.party.join': 'Unirse a nosotros',
  'city.party.bad': 'Un código de fiesta es de cuatro a ocho letras o números.',
  'city.party.code': 'Su código de fiesta es {code}. Comparte con amigos para que puedan unirse.',
  'city.party.alone': 'Nadie más de tu partido está en la ciudad en este momento.',
  'city.party.here': 'Justo a tu lado',
  'city.party.away': '{n} los pasos {dir}',
  'city.party.floor': '( piso {n})',
  'city.party.go': 'Ir a',
  'city.party.leave': 'Deja la fiesta.',
  'city.party.dir.east': 'el este',
  'city.party.dir.south-east': 'Sudeste',
  'city.party.dir.south': 'del sur',
  'city.party.dir.south-west': 'al suroeste',
  'city.party.dir.west': 'Oeste',
  'city.party.dir.north-west': 'al noroeste',
  'city.party.dir.north': 'al norte',
  'city.party.dir.north-east': 'al noreste',
  'city.print.title': 'Imprimir un edificio',
  'city.print.here': '{name}: {w} por {d} celdas, pisos: {n}. Guarde como un STL para una impresora 3D.',
  'city.print.none': 'Estar dentro o al lado de un edificio para guardarlo como un STL para una impresora 3D.',
  'city.print.model': 'Salvación STL, escala modelo (5 mm por célula)',
  'city.print.tabletop': 'Salvar STL, escala de mesa (1 pulgada por célula)',
  'city.print.note': 'Las paredes, los pisos, las puertas, las escaleras y las ventanas mientras la ciudad los dibuja, en una placa base para que imprima en una sola pieza.',
  'city.print.models': 'Figuras y accesorios, listos para imprimir:',
  'city.print.busy': 'Preparándonos...',
  'city.print.model.figure': 'Figura de Walker, 28 mm en una base de 25 mm',
  'city.print.model.fountain': 'Fuente, 3 pulgadas de diámetro',
  'city.print.model.castle-wall': 'Sección de la pared del castillo, 3 pulgadas de largo',
  'city.editor.stl': 'Salvación de STL',
  'city.editor.title': 'Editor de mapas de la ciudad',
  'city.editor.blurb': 'Pinta un mapa de la ciudad piso por piso: paredes, calles, puertas, agua, escaleras y lugares nombrados. El cheque de abajo lo lee con el mismo lector de mapas que utiliza la ciudad viva. Su borrador se guarda en este navegador; exportarlo como un archivo para guardar o compartir.',
  'city.editor.name': 'Nombre del mapa',
  'city.editor.tools': 'Herramientas',
  'city.editor.tool.pen': 'Peno',
  'city.editor.tool.rect': 'Bloqueo',
  'city.editor.tool.room': 'Habitación',
  'city.editor.tool.fill': 'Rellenar',
  'city.editor.tool.spawn': 'Punto de partida',
  'city.editor.tiles': 'El suelo',
  'city.editor.letter': 'La carta',
  'city.editor.placeName': 'Nombre del lugar',
  'city.editor.addPlace': 'Añadir espacio',
  'city.editor.placeBad': 'Un lugar necesita una letra y un nombre.',
  'city.editor.floors': 'Los pisos',
  'city.editor.addFloor': 'Añadir piso',
  'city.editor.map': 'Mapa',
  'city.editor.width': 'Ancho',
  'city.editor.height': 'Alturas',
  'city.editor.new': 'Nuevo mapa',
  'city.editor.undo': 'Deshacerse',
  'city.editor.export': 'Exportación',
  'city.editor.import': 'Importación',
  'city.editor.loaded': 'Mapa cargado.',
  'city.editor.zoom': 'Zoom',
  'city.editor.check': 'El chequeo',
  'city.editor.ok': 'Se lee bien. {walk} celdas abiertas, {reach} accesible desde el punto de partida.',
  'city.editor.placeSpots': '{name}: {n} celdas',
  'city.editor.canvas': 'Canvas del mapa',
  'city.spy.take': 'Toma eso.',
  'city.spy.again': 'Inténtalo de nuevo.',
  'city.spy.drop': 'Deja que se vaya.',
  'city.spy.progress': '{n} por ciento allí.',
  'city.spy.carrying': 'Tienes la nota.',
  'city.spy.underway': 'En camino.',
  'city.spy.done': 'Ya lo he hecho.',
  'city.spy.failed': 'Se salió mal la última vez.',
  'city.menu.look': '¿Qué quieres decir ? {thing}',
  'city.menu.street': 'La calle',
  'city.menu.wall': 'Un muro',
  'city.continue': 'Continúa',
  'city.goodbye': 'Adiós .',
  'city.board.title': 'Tabla de recompensas',
  'city.arrive.rooftops': 'Te subes a los tejados, los carriles se abren por debajo de ti y las tablas entre las casas se deslizan bajo los pies.',
  'city.arrive.museumRoof': 'Te arrastras hasta el techo del museo y Sunwalk Plaza se extiende por debajo de ti como una tabla de juego.',
  'city.crier.title': 'La sábana del gritador',
  'city.crier.today': 'Hoy es {name}.',
  'city.crier.tomorrow': '{name} Es mañana.',
  'city.crier.coming': '{name} en {n} días.',
  'city.crier.stalls': 'En los puestos a primera luz:',
  'city.crier.notices': '{n} avisos en el tablero de recompensas.',
  'city.crier.talk': 'Hablando de la ciudad:',
  'city.crier.now': 'Lo que está sucediendo en la ciudad ahora mismo:',
  'city.board.empty': 'Hoy no hay nada, revisa mañana.',
  'city.board.posted': 'Publicado por: {name}.',
  'city.board.postedAt': 'Publicado por: {name}, ahora en {place}.',
  'city.board.days': '{n} Hay días más.',
  'city.board.find': 'Encuentralas.',
  'city.topics.ask': '{word}?',
  'city.talkWith': 'Hablando con {name}',
  'city.journal': 'Diario',
  'city.journalNone': 'Aún no hay nada escrito.',
  'city.quests': 'Los ramos y los hilos',
  'city.questNone': 'Aún no. Habla con la gente.',
  'city.rest': 'Reposo {n} minutos',
  'city.saves.title': 'Juegos guardados',
  'city.saves.slot': 'Esquina de juego {n}: {day} {time}, {place}',
  'city.saves.empty': 'La ranura {n}: vacía',
  'city.saves.save': 'Ahorra aquí.',
  'city.saves.load': 'Carga',
  'city.saves.sure': 'Toque de nuevo para confirmar',
  'city.saves.hint': 'Un salvamento mantiene a toda la ciudad en su posición: dónde estás, la hora, la gente, las misiones y los cofres.',
  'city.restHint': 'Deja pasar el tiempo, solo puedes descansar tanto en una hora.',
  'city.bed.ask': 'Dormir en {bed}?',
  'city.bed.night': 'Ocho horas pasan mientras duermes, y descansas siguiendo las reglas de tu sistema de juego.',
  'city.bed.sleep': 'Durmiendo',
  'city.bed.notNow': 'No ahora.',
  'city.bed.tired': 'Aún no estás cansado. {n} Las horas.',
  'city.bed.asleep': 'Dormiendo, la noche pasa...',
  'city.bed.offer': 'Dorme aquí.',
  'city.vitals': 'Salud y salud',
  'city.bed.woke': 'Tú duermes en {bed} y despertar en {time}. {change}',
  'city.bed.change': '{label}: {before} a la {after}.',
  'city.bed.noRest': 'El Consejo {system} Las reglas no dan recuperación para el descanso, así que nada repara.',
  'city.bed.beds': 'Las camas',
  'city.bed.demoRules': 'Reglas para la prueba de cama: {system}. Añadir las reglas a la dirección para probar otra.',
  'city.messages': 'Notas',
  'city.rules': 'Sistema de juegos',
  'city.rulesNarrative': 'No hay reglas: la ciudad como una historia. Elige un sistema para ver a todos en sus números.',
  'city.statsFor': 'Números para',
  'city.sparTitle': 'En la práctica .',
  'city.sparA': 'Primero luchador',
  'city.sparB': 'Segundo luchador',
  'city.sparVs': 'contra',
  'city.sparRun': 'Lucha',
  'city.sparNote': 'Una manifestación en este sistema. Nadie en la ciudad está herido.',
  'city.sparRound': 'Ronda {n}.',
  'city.zoomIn': 'Enciende el zoom',
  'city.pivot.left': 'Girar la vista a la izquierda',
  'city.pivot.right': 'Girar la vista a la derecha',
  'city.pivot.north': 'Mirar al norte',
  'city.zoomOut': 'Me acerco .',
  'city.centre': 'Centrarse en mí',
  'city.followOn': 'Sigue adelante .',
  'city.followOff': 'Sigue adelante.',
  'city.followOnHint': 'La cámara te sigue, apaga la cámara para que se haga funcionar libremente.',
  'city.followOffHint': 'Pon y pincha en cualquier lugar. Toca a mí para saltar de nuevo a ti mismo.',
  'city.minimapShow': 'Mostrar el mapa',
  'city.minimapHide': 'Ocultar el mapa',
  'city.minimapOpen': 'Toque para abrirlo más grande.',
  'city.minimapWalk': 'Mapa de la ciudad.',
  'city.minimapSmall': 'Reducir el mapa',
  'city.minimapHint': 'Toque para caminar allí',
  'city.chatter.morning.1.a': 'Pan fresco en los hornos de la esquina, si se apresura.',
  'city.chatter.morning.1.b': 'Lo olí dos calles más allá.',
  'city.chatter.morning.2.a': 'Te has levantado temprano.',
  'city.chatter.morning.2.b': 'Las campanas me despertaron, siempre lo hacen.',
  'city.chatter.morning.3.a': '¿Entraron los carros por la puerta?',
  'city.chatter.morning.3.b': 'Tres de ellos, y uno perdió una rueda en el puente.',
  'city.chatter.morning.4.a': 'Hace frío esta mañana.',
  'city.chatter.morning.4.b': 'La niebla del río se quemará para el mediodía.',
  'city.chatter.morning.5.a': '¿A dónde vas?',
  'city.chatter.morning.5.b': 'El mercado, antes de que las buenas manzanas se hayan ido.',
  'city.chatter.afternoon.1.a': 'Un día ocupado en los puestos.',
  'city.chatter.afternoon.1.b': 'Estoy demasiado ocupado, mis pies se han desviado de mí.',
  'city.chatter.afternoon.2.a': '¿Has visto el bronceador hoy?',
  'city.chatter.afternoon.2.b': 'Bajó al agua hace una hora.',
  'city.chatter.afternoon.3.a': 'El sol es amable hoy.',
  'city.chatter.afternoon.3.b': 'La lluvia está llegando, lo siento en mi rodilla.',
  'city.chatter.afternoon.4.a': '¿Qué quería el vendedor de peces para las anguilas?',
  'city.chatter.afternoon.4.b': 'Compré al menos alquitránes.',
  'city.chatter.afternoon.5.a': '¿Es un carro nuevo?',
  'city.chatter.afternoon.5.b': 'Las ruedas siguen gritando como la vieja.',
  'city.chatter.evening.1.a': '¿Ya vas a casa?',
  'city.chatter.evening.1.b': 'La cena no cocinará por sí misma.',
  'city.chatter.evening.2.a': 'Las lámparas están encendidas.',
  'city.chatter.evening.2.b': 'Entonces vuelvo a llegar tarde.',
  'city.chatter.evening.3.a': '¿Te quedarás en la taberna esta noche?',
  'city.chatter.evening.3.b': 'Si mi esposa me lo permite, sí.',
  'city.chatter.evening.4.a': 'Un día largo.',
  'city.chatter.evening.4.b': 'Todos lo son, en esta época del año.',
  'city.chatter.evening.5.a': 'Cierra las persianas esta noche.',
  'city.chatter.evening.5.b': 'Siempre lo hago, el viento los sacude de todos modos.',
  'city.chatter.night.1.a': '¿Quién va ahí?',
  'city.chatter.night.1.b': 'Sólo yo, baja la linterna.',
  'city.chatter.night.2.a': 'Deberías estar dormido.',
  'city.chatter.night.2.b': 'Tú también deberías, amigo.',
  'city.chatter.night.3.a': '¿Oíste algo junto al agua?',
  'city.chatter.night.3.b': 'Los gatos, siempre son gatos.',
  'city.chatter.night.4.a': 'Noche tranquila.',
  'city.chatter.night.4.b': 'Vamos a mantenerlo así.',
  'city.chatter.any.1.a': '¿Has oído las noticias?',
  'city.chatter.any.1.b': 'Siempre hay noticias.',
  'city.chatter.any.2.a': 'Buen día para ti.',
  'city.chatter.any.2.b': 'Y para ti también.',
  'city.chatter.any.3.a': 'Mi primo jura que la vieja torre está encantada.',
  'city.chatter.any.3.b': 'Tu primo jura muchas cosas.',
  'city.chatter.any.4.a': 'Los precios siguen subiendo.',
  'city.chatter.any.4.b': 'Y mi salario sigue parado.',
  'city.chatter.any.5.a': 'Cuidado con el charco.',
  'city.chatter.any.5.b': 'Demasiado tarde, gracias de todos modos.',
  'city.chatter.any.6.a': '¿Ese es el extraño que todos mencionan?',
  'city.chatter.any.6.b': 'No me mires, es grosero.',
  'city.chatter.any.7.a': '¿Cómo está tu madre?',
  'city.chatter.any.7.b': 'Mejor, gracias, ella vuelve a regañarme.',
  'city.chatter.any.8.a': 'Te debo una copa, ¿verdad?',
  'city.chatter.any.8.b': 'Dos, según mi cuenta.',
  'city.inventory.title': 'Su maleta',
  'city.inventory.subtitle': 'Montkelian el bolso',
  'city.inventory.close': 'Cierra tu maleta',
  'city.inventory.tabs': 'Secciones de embalaje',
  'city.inventory.tab.inventory': 'Inventario',
  'city.inventory.tab.journal': 'Diario',
  'city.inventory.tab.map': 'Mapa',
  'city.inventory.empty': 'Su maleta está vacía, las cosas que encuentren en sus viajes se guardarán en estos bolsillos.',
  'city.inventory.slots': 'Los bolsillos',
  'city.inventory.slotEmpty': 'El bolsillo {n}, vacío',
  'city.inventory.slot.headgear': 'Vestido para la cabeza',
  'city.inventory.slot.helmet': 'El casco',
  'city.inventory.slot.hat': 'El sombrero',
  'city.inventory.slot.hood': 'El capullo',
  'city.inventory.slot.amulet': 'Amuleto',
  'city.inventory.slot.cloak': 'Camacho',
  'city.inventory.slot.tabard': 'Tabardo',
  'city.inventory.slot.pelt': 'Peludo',
  'city.inventory.slot.armor': 'Armadura',
  'city.inventory.slot.plate': 'Placas',
  'city.inventory.slot.robe': 'La ropa',
  'city.inventory.slot.jerkin': 'Qué tonto.',
  'city.inventory.slot.hide': 'Esconderse',
  'city.inventory.slot.girdle': 'Corazón',
  'city.inventory.slot.belt': 'Cinturón',
  'city.inventory.slot.bracers': 'Las máquinas de corte',
  'city.inventory.slot.gloves': 'Guantes y guantes',
  'city.inventory.slot.mainHand': 'La mano principal',
  'city.inventory.slot.offHand': 'Descanso de mano',
  'city.inventory.slot.twoHand': 'Las dos manos',
  'city.inventory.slot.sword': 'La espada',
  'city.inventory.slot.shield': 'Escudo',
  'city.inventory.slot.staff': 'El personal',
  'city.inventory.slot.focus': 'Concentrarse',
  'city.inventory.slot.ring': 'El anillo',
  'city.inventory.slot.leggings': 'Leggings',
  'city.inventory.slot.greaves': 'Los grados',
  'city.inventory.slot.boots': 'Las botas',
  'city.inventory.item.sword': 'La espada',
  'city.inventory.item.shield': 'Escudo',
  'city.inventory.item.knife': 'Cuchillo',
  'city.inventory.item.axe': 'El hacha',
  'city.inventory.item.tabard': 'Tabardo',
  'city.inventory.item.cape': 'Cabo',
  'city.inventory.item.ring': 'El anillo',
  'city.inventory.class.default': 'viajero',
  'city.inventory.class.fighter': 'luchador',
  'city.inventory.class.paladin': 'paladín',
  'city.inventory.class.berserker': 'de la ciudad de Berserker',
  'city.inventory.class.wizard': 'el mago',
  'city.inventory.class.rogue': 'Deshonesto',
  'city.inventory.slotFree': 'En vacío',
  'city.inventory.gear': 'Lo que llevas puesto',
  'city.inventory.view': 'El espectáculo',
  'city.inventory.viewGear': 'Desgastado',
  'city.inventory.viewPockets': 'Los bolsillos',
  'city.inventory.avatarHint': 'Elige un avatar diferente del menú, bajo Avatar.',
  'city.inventory.soon.journal': 'Su diario está en blanco por ahora, las misiones y notas que recopilen se escribirán aquí.',
  'city.inventory.soon.map': 'Su mapa doblado se guardará aquí, marcado con los lugares que ha estado.',
  'city.inventory.hint': 'Golpearse para abrir su maleta',
  'city.avatar': 'Avatar',
  'city.avatarLabel': 'Elige tu avatar',
  'city.avatar.robot': 'Robótico',
  'city.avatar.nycanthea': 'Nycanthea',
  'city.avatar.paladin': 'Paladino',
  'city.avatarCloth': 'Tela',
  'city.avatarClothHint': 'Las capas y los tabardos se balancean a medida que se mueven',
  'city.soundOn': 'Encienda el sonido',
  'city.soundOff': 'Apagar el sonido',
  'city.musicOn': 'Juega música',
  'city.musicOff': 'Deja la música.',
  'city.walkSpeed': 'Velocidad',
  'city.walkSpeedLabel': 'Velocidad de marcha',
  'city.walkSpeedValue': '{n}x',
  'city.me': 'Yo también.',
  'city.quality': 'Calidad',
  'city.qualityAuto': 'Auto ({tier})',
  'city.tier.low': 'Bajo',
  'city.tier.medium': 'Medios',
  'city.tier.high': 'Altos',
  'city.robot.keys': 'Las llaves del robot',
  'city.robot.title': 'Las llaves del robot',
  'city.robot.intro': 'Presione una tecla, o toque aquí, y su robot lo hace para que todos los cercanos lo vean. Es solo para mostrar y no cambia nada en el juego.',
  'city.robot.close': 'Cercano',
  'city.robot.jumpNote': 'Presione el espacio de nuevo mientras está en el aire para dar doble salto.',
  'city.robot.spellNote': 'En el modo de hechizo, 1, 2 y 3 se lanzan en lugar de ataque.',
  'city.robot.climbNote': 'Para subir y bajar de la página, puede subir las escaleras, escaleras o tuberías de drenaje más cercanas a su hogar.',
  'city.robot.walkNote': 'W, A, S y D caminan hacia el norte, oeste, sur y este un paso a la vez.',
  'city.robot.walk.north': 'Camina hacia el norte.',
  'city.robot.walk.west': 'Camina hacia el oeste',
  'city.robot.walk.south': 'Camina hacia el sur.',
  'city.robot.walk.east': 'Camina hacia el este.',
  'city.stairs.label': 'Cama por las escaleras .',
  'city.stairs.up': 'Alza .',
  'city.stairs.down': 'Bajo .',
  'city.stairs.goUp': 'Sube un piso .',
  'city.stairs.goDown': 'Baja un piso .',
  'city.robot.toggleNote': 'Modo de arma, Modo de hechizo, Sneak, Dance y Fall abajo permanecen hasta que los presiones de nuevo.',
  'city.robot.typing': 'Las llaves no hacen nada mientras escribe en una caja.',
  'city.robot.inSpell': 'Modo de hechizo: {act}',
  'city.robot.otherwise': 'En caso contrario: {act}',
  'city.robot.pad': 'Acciones',
  'city.robot.padShow': 'Muestre el panel de acción',
  'city.robot.padHide': 'Esconde la almohadilla de acción',
  'city.robot.padTouch': '(para pantallas táctiles)',
  'city.robot.noLadder': 'No hay escaleras ni escaleras cerca',
  'city.robot.act.jump': 'Salta .',
  'city.robot.act.double-jump': 'Salto doble',
  'city.robot.act.dodge': '- No lo sé.',
  'city.robot.act.block': 'Bloqueo o defensa',
  'city.robot.act.parry': '- ¿Qué es eso?',
  'city.robot.act.weapon-mode': 'Modo de arma',
  'city.robot.act.spell-mode': 'Modo de hechizo',
  'city.robot.act.slash': 'El corte',
  'city.robot.act.thrust': 'El empuje',
  'city.robot.act.flurry': '- ¿Qué quieres decir?',
  'city.robot.act.cast': 'El reparto',
  'city.robot.act.cast-spell': 'El hechizo de lanzamiento',
  'city.robot.act.megacast': 'Megacast',
  'city.robot.act.duck': '- El pato .',
  'city.robot.act.sneak': 'Esquivo',
  'city.robot.act.sing': 'Cantar .',
  'city.robot.act.dance': 'Baila',
  'city.robot.act.barf': 'El barf',
  'city.robot.act.fall': 'Caer o levantarse',
  'city.robot.act.climb-up': 'Sube hacia arriba.',
  'city.robot.act.climb-down': 'Desciende .',
  'city.robot.act.hurt': 'Toma un golpe .',
  'city.robot.act.kneel': 'Rodillas y pie',
  'city.robot.act.bow': 'El arco',
  'city.robot.act.cheer': 'Felicitación por la victoria',
  'city.panelShow': 'Panel de visualización',
  'city.phone.menu': 'Menú',
  'city.phone.close': 'Menú cerrado',
  'city.phone.view': 'Mapa',
  'city.phone.sound': 'Sonido y ritmo',
  'city.phone.people': 'Encuentra a alguien.',
  'city.phone.more': 'Todo lo demás .',
  'city.phone.hint': 'Golpea el suelo para caminar, golpea a una persona para hablar.',
  'city.phone.gotIt': 'Ya lo tengo.',
  'city.panelHide': 'Panel de ocultamiento',
  'city.canvasLabel3d': 'Mapa de {city} el panel incluye a todos y todo aquí también',
  'city.dock.label': 'Personas para encontrar',
  'city.dock.go': 'Camina hacia {name}',
  'city.dock.walking': 'Caminando hacia {name}',
  'city.dock.toPlace': 'Caminando hacia {name} en el {place}',
  'city.dock.cancel': 'Golpea el suelo para detenerse',
  'city.rigDebug.open': 'Descargar cómo {name} movimientos',
  'city.rigDebug.title': 'Desarrollo del equipo: {name}',
  'city.rigDebug.close': 'Cercano',
  'city.rigDebug.move': 'Muévete',
  'city.rigDebug.facing': 'Enfrentado',
  'city.rigDebug.allMoves': 'Todos los movimientos',
  'city.rigDebug.allFacings': 'Todas las caras',
  'city.rigDebug.cycling': 'Ciclismo, {s} cada uno',
  'city.rigDebug.play': 'Juega',
  'city.rigDebug.pause': 'Pausa .',
  'city.rigDebug.back': 'Un paso atrás un marco',
  'city.rigDebug.forward': 'Un paso adelante un marco',
  'city.rigDebug.speed': 'Velocidad',
  'city.rigDebug.hint': 'Pausa para dar paso a paso, pulsa afuera o pulsa Escape para cerrar.',
  'city.rigDebug.anim.idle': 'Ocio',
  'city.rigDebug.anim.walk': 'Caminar',
  'city.rigDebug.debug': 'Debug',
  'city.rigDebug.viewLabel': 'Vista',
  'city.rigDebug.view.2d': '2D',
  'city.rigDebug.view.iso': 'Específicos',
  'city.rigDebug.view.3d': '3D',
  'city.rigDebug.facingIs': 'de cara a cara {dir}',
  'city.rigDebug.cell': 'en la fila {row}, marco {col}',
  'city.rigDebug.loading': 'carga',
  'city.rigDebug.clip': 'Clip',
  'city.rigDebug.allClips': 'Todos los clips',
  'city.rigDebug.noClips': 'No hay clips.',
  'city.rigDebug.layers': 'El espectáculo',
  'city.rigDebug.show.model': 'Modelo',
  'city.rigDebug.show.bones': 'Huesos',
  'city.rigDebug.show.pieces': 'Las piezas',
  'city.rigDebug.boneCount': '{n} huesos',
  'city.rigDebug.no3d': 'La vista en 3D no pudo arrancar en esta pantalla.',
  'city.rigDebug.hint3d': 'Arrastre para girar la cámara, haga una pausa paso a paso, pulse hacia afuera o pulse Escape para cerrar.',
  'city.rigDebug.standIn': '{name} se muestra en el {body} El cuerpo está aquí hasta que el suyo esté listo.',
  'city.rigDebug.archive': 'Archivo',
  'city.rigDebug.archivePose': 'Presentación de la pose: vea cómo {name} movimientos',
  'city.pose.open': 'Veamos cómo {name} movimientos',
  'city.pose.robot': 'Usted (robot sustituyente)',
  'city.pose.you': 'Tú también .',
  'city.pose.see': 'Vean cómo se mueven.',
  'city.pose.youTitle': 'Cómo te mueves',
  'city.pose.openYou': 'Mira cómo te mueves.',
  'city.pose.title': '¿Cómo lo hizo? {name} movimientos',
  'city.pose.allTitle': 'Todas las poses',
  'city.pose.all': 'Muestre todas las poses',
  'city.pose.one': 'Sólo ... {name}',
  'city.pose.close': 'Cercano',
  'city.pose.hint': 'Toca afuera para cerrar',
  'city.pose.loading': 'Carga',
  'city.pose.anim.idle': 'Ocio',
  'city.pose.anim.walk': 'Caminar',
  'city.pose.anim.talk': 'Habla',
  'city.pose.anim.sit': 'Siéntate.',
  'city.pose.anim.run': 'Corra .',
  'city.pose.drag': 'Arrastrar para girar',
  'city.pose.gait': 'Movimiento',
  'city.pose.model': '{name} en 3D',
  'city.pose.dir.SW': 'hacia el suroeste',
  'city.pose.dir.SE': 'hacia el sureste',
  'city.pose.dir.NE': 'hacia el noreste',
  'city.pose.dir.NW': 'hacia el noroeste',
  'city.demoLink': 'Abre la demostración del renderizado',
  'city.demoTitle': 'Demo del renderizado',
  'city.demoNote': 'Una vista previa local de la ciudad 3D con caminantes de pie.',
  'city.demoTime': 'La hora del día',
  'city.demoSeason': 'Temporada',
  'city.demoPlay': 'Conduce el reloj .',
  'city.demoPause': 'Detenga el reloj .',
  'city.demoTower': 'Torre de ensayo',
  'city.demoTowerNote': 'Un edificio de cuatro pisos para comprobar lo que se puede ver en el interior. En el interior, los pisos por encima de usted están cortados y todo lo que no se puede ver desde donde usted está de pie es grisado.',
  'city.demoGoTower': 'Caminar hasta la torre',
  'city.demoFloor': 'El piso: {floor}',
  'city.demoFloor0': 'El suelo',
  'city.demoFloor1': 'El segundo',
  'city.demoFloor2': 'El tercer',
  'city.demoFloor3': 'Cuarto',
  'city.demoFloor4': 'Techo',
  'city.demoWindow': 'Ventana del tercer piso',
  'city.demoRoom': 'cuarto interior del tercer piso',
  'city.demoUp': 'Un piso arriba',
  'city.demoDown': 'Bajo un piso',
  'city.makeWay.polite': 'Oh, lo siento.',
  'city.makeWay.gruff': '¡Cuidado con dónde caminas!',
  'city.makeWay.immovable': 'No me voy a mover.',
  'city.makeWay.busy': 'Cuidado con el camino.',
  'cascade.seoTitle': 'Debugger de cascada',
  'cascade.title': 'Debugger de cascada',
  'cascade.intro': 'El lado del estilo se extiende desde el sistema hasta el director artístico. El lado heredero es toda la taxonomía, desde cada racimo raíz hasta las especies y los linajes que se sientan en ellos. Abre cualquier fila para leer el texto completo.',
  'cascade.readOnly': 'Nada en esta pantalla puede cambiar una solicitud.',
  'cascade.fetchedAt': 'Se lee desde la API de contenido en {time}',
  'cascade.refresh': 'Lea otra vez',
  'cascade.loading': 'Leyendo ambas cascadas...',
  'cascade.error': 'No pude leer las cascadas de la API de contenido.',
  'cascade.forbidden': 'Esta pantalla es para los administradores del sitio. Su cuenta está conectada pero no tiene el papel de administrador.',
  'cascade.style.title': 'Cascada de estilo',
  'cascade.style.subtitle': 'Sistema, editor, línea de productos, configuración, tipo de medios, libro y director artístico.',
  'cascade.style.focus': 'Sigue la cadena para',
  'cascade.style.counts': '{nodes} filas de estilo, {edges} conexiones, {media} plantillas de medios',
  'cascade.taxa.title': 'Cascada de herederos',
  'cascade.taxa.subtitle': 'Cada nodo añade su propio prompt a todo lo que hereda de los nodos por encima de él.',
  'cascade.taxa.group': 'Grupo de inmediato',
  'cascade.taxa.find': 'Encuentra un taxón o linaje',
  'cascade.taxa.findPlaceholder': 'Homo, Terrana, un nombre de linaje...',
  'cascade.taxa.counts': '{taxa} los taxones, {prompts} las instrucciones de taxones, {lineages} linajes',
  'cascade.taxa.shardCounts': '{taxa} los taxones, {prompts} las filas rápidas',
  'cascade.taxa.truncated': 'La API de contenido corta la lista de instrucciones de este fragmento, por lo que algunas filas pueden estar faltando aquí.',
  'cascade.taxa.emptyShards': 'Las partículas sin taxones todavía: {names}',
  'cascade.taxa.orphans': 'Los linajes que apuntan a un taxón no en ningún árbol',
  'cascade.taxa.noOwn': 'No hay ninguna señal propia para este grupo.',
  'cascade.taxa.inherits': 'Los herederos de arriba',
  'cascade.taxa.inheritsNothing': 'Nada heredado. Aquí es donde comienza la cadena.',
  'cascade.taxa.through': 'Compuesto a través de este nodo',
  'cascade.taxa.lineages': 'Los linajes de esta especie',
  'cascade.level.system': 'El sistema',
  'cascade.level.publisher': 'El editor',
  'cascade.level.product_line': 'Línea de productos',
  'cascade.level.setting': 'Configuración',
  'cascade.level.media': 'Tipo de medios',
  'cascade.level.book': 'Libro',
  'cascade.level.art_director': 'Director de arte',
  'cascade.empty.system': 'No hay línea de estilo de sistema en esta cadena.',
  'cascade.empty.publisher': 'No hay línea de estilo de editores todavía. Este nivel está vacío.',
  'cascade.empty.product_line': 'No hay línea de estilo de la línea de productos en esta cadena.',
  'cascade.empty.setting': 'No hay línea de estilo de ajuste en esta cadena.',
  'cascade.empty.media': 'No se aplican plantillas de tipo de medio a esta cadena.',
  'cascade.empty.book': 'No hay ninguna línea de estilo de libro que se cuelgue de este entorno.',
  'cascade.empty.art_director': 'Ningún director de arte está conectado a esta cadena.',
  'cascade.missing': 'Nivel faltante',
  'cascade.others': 'Otras filas en este nivel ({count})',
  'cascade.mediaSpeciesNote': '{count} las plantillas de especies se muestran en el lado heredero, bajo sus linajes.',
  'cascade.field.id': 'el número de identidad',
  'cascade.field.scope': 'el alcance',
  'cascade.field.scopeId': 'Identificación de alcance',
  'cascade.field.group': 'grupo',
  'cascade.field.mediaType': 'Tipo de medio',
  'cascade.field.prompt': 'de inmediato',
  'cascade.field.negative': 'negativo',
  'cascade.field.defaults': 'por defecto',
  'cascade.field.refs': 'imágenes de referencia',
  'cascade.field.chars': '{count} caracteres',
  'cascade.field.empty': 'vacío',
  'cascade.facet.art_direction': 'El núcleo',
  'cascade.facet.art_direction_character': 'Personaje',
  'cascade.facet.art_direction_scene': 'Escenas',
  'cascade.facet.art_direction_interface': 'Interfaz',
  'cascade.facet.art_direction_cartography': 'Cartografía',
  'cascade.facet.art_direction_audiobook': 'Libro de audio',
  'cascade.facet.art_direction_movie': 'Película',
  'cascade.facet.art_direction_short': 'Corto',
  'cascade.facet.art_direction_tvshow': 'El programa de televisión',
  'cascade.composed.title': 'Compuesto para {name}',
  'cascade.composed.layers': 'Las capas, de ancho a estrecho',
  'cascade.composed.preview': 'Imágenes compuestas',
  'cascade.composed.previewNote': 'Se ensamblan en esta pantalla desde las filas anteriores en orden en cascada: estilo de núcleo, faceta de caracteres, plantillas de medios, rasgos de taxones, luego la línea de impresión que el generador agrega en código.',
  'cascade.composed.negative': 'Compuesto negativo',
  'cascade.composed.fromCode': 'añadido en código, no almacenado en ninguna fila',
  'cascade.flags.duplicates': 'Lo dije dos veces.',
  'cascade.flags.conflicts': 'Términos negativos que también aparecen en la solicitud',
  'cascade.flags.none': 'No hay frases repetidas ni términos negativos que choquen con el aviso.',
  'cascade.flags.in': 'en {sources}',
  'cascade.source.styleCore': 'el núcleo de estilo',
  'cascade.source.styleCharacter': 'faceta de carácter de estilo',
  'cascade.source.media': 'plantilla de medios, {scope}',
  'cascade.source.taxon': 'taxón {rank} {value}',
  'cascade.source.printSafe': 'línea de impresión (código)',
  'cascade.rank.domain': 'dominio',
  'cascade.rank.kingdom': 'reino',
  'cascade.rank.phylum': 'de la familia de los',
  'cascade.rank.class': 'clase',
  'cascade.rank.ordem': 'orden',
  'cascade.rank.family': 'familia',
  'cascade.rank.genus': 'género',
  'cascade.rank.species': 'las especies',
  'cascade.rank.shard': 'la hoja de hierro',
}
